/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react"
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar"
import { Alert, AlertColor } from "@mui/material"

import DialogService from "../../services/dialog"
import { DialogType } from "../../models/dialog"

const CwSnackBar = (): React.JSX.Element | null => {
    const [params, setParams] = useState<{
        isOpen: boolean
        text: string
        duration: number
        type: AlertColor
        anchorOrigin: SnackbarOrigin
    }>({
        isOpen: false,
        text: "",
        duration: 5000,
        type: "info",
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
        },
    })

    useEffect(() => {
        // init la SnackBar n s'abonnant aux Action de type SHOW
        DialogService.getInstance().subscribe(
            "all",
            DialogType.SHOW,
            "SnackBar",
            (param: any) => {
                setParams({
                    isOpen: !!param.open,
                    text: param.text ? param.text : "",
                    duration: param.duration ? param.duration : 5000,
                    type: param.type ? param.type : "info",
                    anchorOrigin: param.anchorOrigin
                        ? param.anchorOrigin
                        : {
                              vertical: "bottom",
                              horizontal: "center",
                          },
                })
            }
        )
    }, [])

    const handleClose = () => {
        setParams({ ...params, isOpen: false })
    }

    return params.isOpen ? (
        <Snackbar
            open={params.isOpen}
            anchorOrigin={params.anchorOrigin}
            autoHideDuration={params.duration}
            onClose={handleClose}
            sx={{ zIndex: 20000 }}
        >
            <Alert
                onClose={handleClose}
                severity={params.type}
                variant="filled"
                style={{ color: "#fff", whiteSpace: "pre-line" }}
            >
                {params.text}
            </Alert>
        </Snackbar>
    ) : null
}
export default CwSnackBar
